import * as React from 'react'
import { withStyles, WithStyles } from '@zn-material-ui'
import Store from 'store'
import { News as Setting, Login } from '@services/api'
import UserStore from '@stores/UserStore'
import { observer, inject } from 'mobx-react'
import ConfirmDialog from '@components/Dialog'
import AppListDialog from '../components/AppListDialog'
import loginStyles from './styles/LoginFormStyle'
import { getHomeList } from '../Login/helper'
import {
  LoginBodyCodeEnum,
  IIdentytyItem,
  IIdentytySelectItem,
} from '../Login/type'
import { IProps as ILoginProps } from '../Login'
import { transform } from '@utils/intl_lang'
export const queryOperationList = async () => {
  const { code, message, body } = await Login.queryOperationList()
  if (code !== 0) {
    global.$message(message)
    return
  }
  Store.set('operationList', body)
  UserStore.setOperationList(body)
}
export const setStore = ({
  enterpriseId,
  enterpriseName,
  sid,
  userId,
}: IStore) => {
  const data = { enterpriseId, enterpriseName, sid, userId }
  UserStore.updateLoginInfo.apply(UserStore, [...Object.values(data), appId])
  Store.set('sessionInfo', { ...data, appId })
  window.sessionStorage.setItem('__zn__sid', sid)
}
export const appId = 'com.mlearning.guangqichuanqi'

export const getToken = () => {
  const search = location.href.split('?')[1]
  if (search) {
    const tokenStr = search.split('&').find(v => v.includes('token'))
    return (tokenStr && tokenStr.split('=')[1]) || ''
  }
  return ''
}
interface IProps extends ILoginProps, WithStyles<typeof loginStyles> {}

interface IStore {
  enterpriseId: string
  enterpriseName: string
  sid: string
  userId: string
}

const initialState = {
  appListDialogVisible: false,
  loginLoading: false,
  dialogData: [] as IIdentytySelectItem[],
  // dialogType: 1, // 0为企业身份即APP身份，1为个人企业内部身份，这里企业身份是固定的为e祺学
  loginUrl: '',
  dialogVisible: false,
  forceLoginToken: '',
}

type IState = Readonly<typeof initialState>

@inject('UserStore', 'AppStore')
@observer
class LoginForm extends React.Component<IProps, IState> {
  public state = initialState

  public componentDidMount() {
    const token = getToken()
    if (token) {
      this.yizhangtongLogin(token)
    }
    this.fetchLoginUrl()
  }
  public componentDidUpdate(nextProps: IProps) {
    if (getToken() && window.pushOneLogin) {
      window.pushOneLogin = false
      this.yizhangtongLogin(getToken())
    }
  }
  public render() {
    const { classes } = this.props
    const {
      appListDialogVisible,
      loginLoading,
      dialogData,
      loginUrl,
      dialogVisible
    } = this.state
    return (
      <>
        <div className={classes.loginForm}>
          <div className={classes.back} onClick={this.handleBack} />
          <div className={classes.loginContainer}>
            <div className={classes.title}>
              <div className={classes.hello}>HELLO</div>
              {/* 一账通登录 */}
              <div className={classes.welcome}>
                {transform('Login_one_account_login')}
              </div>
              <div className={classes.titleLine} />
            </div>
            <div className={classes.innerWrapper}>
              {(loginUrl && (
                <iframe
                  id="loginContent"
                  width="100%"
                  height="100%"
                  className="loginContent"
                  src={loginUrl}
                />
              )) ||
                null}
            </div>
          </div>
        </div>
        {appListDialogVisible && (
          <AppListDialog
            data={dialogData}
            // "身份"
            title={transform('Login_identity')}
            loading={loginLoading}
            handleSelect={this.handleSelectApp}
          />
        )}
        <ConfirmDialog
          visible={dialogVisible}
          confirmAndCancel={true}
          content={'您已登录PC直播端，在智门户登录后PC直播端将自动下线，请确认是否登录'}
          onOk={this.forceLogin}
          onCancel={this.cancelLogin}
        />
      </>
    )
  }
  // 取消登录
  private cancelLogin = () => {
    this.setState({ dialogVisible: false })
    this.fetchLoginUrl()
  }
  // 确定登陆
  private forceLogin = async () => {
    const { forceLoginToken } = this.state
    const token = getToken()
    const data = {
      token,
      forceKickOut: 1,
      forceLoginToken
    }
    const res = await Login.yztLogin(data)
    if ( res && res._failure ) { return }

    setStore(res.body)
    queryOperationList()
    // 强制登录，跳首页
    const { history, AppStore } = this.props
    getHomeList({ history, AppStore })
  }

  private handleBack = () => {
    this.props.history.push('/login')
  }

  private fetchLoginUrl = async () => {
    const result = await Login.getYZTLgoinUrl()
    if (result.body && result.body.loginUrl) {
      this.setState({ loginUrl: result.body.loginUrl })
    } else {
      global.$message(result.message)
    }
  }

  private handleSelectApp = (enterpriseId: string) => async () => {
    // 选择身份
    const { dialogData } = this.state
    const item = dialogData.find(d => d.value === enterpriseId)
    if (!item) {
      return
    }
    UserStore.updateIdentity(enterpriseId, item.title) // 根据身份更新企业ID及名称
    Store.set('sessionInfo', {
      ...Store.get('sessionInfo'),
      enterpriseId,
      enterpriseName: item.title,
    })
    window.sessionStorage.setItem('__zn__sid', Store.get('sessionInfo').sid)
    const empId = item.empId
    const result = await Setting.enterpriseIsActive(appId, empId, enterpriseId) // 校验权限

    if (+result.code !== 0) {
      global.$message(result.message)
      return
    }
    if (+result.body.isSuccess === 1) {
      this.setState({ loginLoading: true })
      const result1 = await Login.sidIsEffective() // 登录
      const bodyCode = result1.body.bodyCode
      this.setState({ loginLoading: false })

      if (+result1.code !== 0) {
        global.$message(result1.message)
        return
      }
      setStore(result1.body)
      queryOperationList()

      if (
        bodyCode === LoginBodyCodeEnum.VALID ||
        bodyCode === LoginBodyCodeEnum.VALID_WITH_NOT_IDENTITY
      ) {
        // 正常登录，跳首页
        const { history, AppStore } = this.props
        getHomeList({ history, AppStore })
      } else {
        this.props.history.push('/noPermission/1')
      }
    }
  }

  private yizhangtongLogin = async (token: string) => {
    this.setState({ loginUrl: '' })
    const { code, message, body } = await Login.yztLogin({token})
    const { bodyCode, forceLoginToken } = body
    if (+code !== 0) {
      this.setState({ loginLoading: false, appListDialogVisible: false })
      global.$message(message)
      return
    }
    if (bodyCode === LoginBodyCodeEnum.ACCOUNT_LOGIN_ANOTHER) {
      // 已经在PC直播端登录
      this.setState({ dialogVisible: true, forceLoginToken })
      return
    }

    setStore(body)
    queryOperationList()

    if (
      bodyCode === LoginBodyCodeEnum.VALID ||
      bodyCode === LoginBodyCodeEnum.VALID_WITH_NOT_IDENTITY
    ) {
      const { history, AppStore } = this.props
      getHomeList({ history, AppStore })
    } else if (bodyCode === LoginBodyCodeEnum.MULTI_IDENTITY) {
      if (body.userArr.length) {
        const dialogData = body.userArr.map((item: IIdentytyItem) => ({
          title: item.enterpriseName,
          value: item.enterpriseId,
          empId: item.empId,
        }))
        this.setState({
          loginLoading: false,
          appListDialogVisible: true,
          dialogData,
        })
      }
    } else if (bodyCode === LoginBodyCodeEnum.NO_BINDING_PHONE) {
      this.props.history.push(`/binding/${getToken()}`)
    } else {
      this.props.history.push('/noPermission/1')
    }
  }
}

export default withStyles(loginStyles)(LoginForm)
